export interface AttributeValue {
    Utc: string;
    Value: string | number;
}

export type Attribute = {
    Name: string;
    Values: AttributeValue[];
    Guid: string;
    Element: string;
    Uom: string;
}

export function firstValue(attribute: Attribute): string | Number | undefined {
    if (!isAttributeValid(attribute)) {
        console.log("attribute is invalid");
        return "-";
    }
    return attribute.Values[0].Value;
}

export function firstValueAsString(attribute: Attribute): string | undefined {
    if (!isAttributeValid(attribute)) {
        console.log("attribute is invalid");
        return "-";
    }
    return attribute.Values[0].Value.toString();
}

export function firstValueAsNumber(attribute: Attribute): number {
    if (!isAttributeValid(attribute)) {
        console.log("attribute is invalid");
        return Number.NaN;
    }

    if (typeof attribute.Values[0].Value === "number") {
        return attribute.Values[0].Value as number;
    }
    return Number.NaN;
}

export function lastValueAsNumber(attribute: Attribute): number {
    if (!isAttributeValid(attribute)) {
        console.log("attribute is invalid");
        return Number.NaN;
    }

    if (typeof attribute.Values[attribute.Values.length - 1].Value === "number") {
        return attribute.Values[attribute.Values.length - 1].Value as number;
    }
    return Number.NaN;
}



export function filterByTimeRange(attribute: Attribute, hours: number) {
    if (attribute.Values.length === 0) return { Name: "", Values: [{ Utc: new Date().toISOString(), Value: Number.NaN }], Guid: "", Element: "", Uom: "" };

    const currentTime = new Date();
    const startTime = new Date(currentTime.getTime() - hours * 60 * 60 * 1000);

    const filteredValues = attribute.Values.filter((value) => {
        const valueTime = new Date(value.Utc);
        return valueTime >= startTime && valueTime <= currentTime;
    });

    return { ...attribute, Values: filteredValues };
}


function isAttributeValid(attribute: Attribute): boolean {
    return attribute !== undefined &&
        attribute !== null &&
        attribute.Values !== undefined &&
        attribute.Values !== null &&
        attribute.Values.length > 0;
}